import { debug, NetbankingAPI } from "aaa";
import { action, observable } from "mobx";
import { NetbankingAPIClient } from "network/APIClient";
import { ILandingPageType } from "types/landingPage";
import { IPluginDetails } from "types/plugins";
import { IProductDetails } from "types/products";

class LandingPageStore {
    @observable isLoading: boolean = false;
    @observable productDetails?: IPluginDetails[];
    @observable pluginDetails?: IProductDetails[];

    getLandingPageTarget(type: ILandingPageType) {
        switch (type) {
            case "PRODUCT": return NetbankingAPI.getProductDetails();
            case "PLUGIN": return NetbankingAPI.getPluginDetails();
            default: return null;
        }
    }

    getDetails(type: ILandingPageType, code: string) {
        if (type === "PRODUCT" && this.productDetails) {
            return this.productDetails.find(product => product.externalId === code) || null;
        } else if (type === "PLUGIN" && this.pluginDetails) {
            return this.pluginDetails.find(plugin => plugin.externalId === code) || null;
        }

        return null;
    }

    @action async load(type: ILandingPageType) {
        if (
            (type === "PRODUCT" && this.productDetails) ||
            (type === "PLUGIN" && this.pluginDetails)
        ) {
            return;
        }

        this.isLoading = true;

        try {
            const target = this.getLandingPageTarget(type);

            if (target) {
                const details = await NetbankingAPIClient.requestType(target);

                if (type === "PRODUCT") {
                    this.productDetails = details;
                } else if (type === "PLUGIN") {
                    this.pluginDetails = details;
                }
            } else {
                debug.log("### LandingPageStore no target for type " + type);
            }

            this.isLoading = false;
        } catch (err) {
            this.isLoading = false;
            debug.log("### LandingPageStore failed to load data for type " + type);
            throw err;
        }
    }
}

const landingPageStore = new LandingPageStore();
export { landingPageStore };


// WEBPACK FOOTER //
// ./src/stores/LandingPageStore.ts